import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../utils/APIS";
import { IDS } from "../utils/IDS";
import { GET, POST } from "../utils/Methods";

export const GetAllAppsetup = createAsyncThunk(
  "masters/appsetup/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.appsetup}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "app_setup",
  initialState: {
    appsetup: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(GetAllAppsetup.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllAppsetup.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.alltypes = action.payload?.data || [];
        state.appsetup = action.payload.data || [];
      })
      .addCase(GetAllAppsetup.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload.data;
      });
  },
});

export default Slice.reducer;
